// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as bootstrap from "bootstrap"

// Initialize Bootstrap components that need JavaScript
document.addEventListener("turbo:load", () => {
  // Initialize all dropdowns
  const dropdowns = document.querySelectorAll('[data-bs-toggle="dropdown"]')
  dropdowns.forEach(dropdown => new bootstrap.Dropdown(dropdown))

  // Initialize all tooltips
  const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  tooltips.forEach(tooltip => new bootstrap.Tooltip(tooltip))
})
